import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import requestStatusTypes from '../../constants/requestStatusTypes';
import AiSearchResultsContainer from './AiSearchResultsContainer';
// @ts-expect-error Untyped import
import { selectSearchFilter } from '../../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { selectAiSearchResponse } from '../../selectors/reportsSelector';
import { Box } from 'foundations-components/transitional/components/Box';
// @ts-expect-error Untyped import
import { selectAiSearchRequestStatus } from '../../selectors/reportsSelector';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import AiSearchResultsError from '../../components/aiSearchResults/AiSearchResultsError';
import AiSearchResultItemSkeleton from '../../components/aiSearchResults/AiSearchResultItemSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AiReadyMadeReportsContainer = () => {
  const aiSearchResponse = useSelector(selectAiSearchResponse);
  const aiSearchRequestStatus = useSelector(selectAiSearchRequestStatus);
  const search = useSelector(selectSearchFilter);
  const loadingSkeletonArray = Array.from({
    length: 4
  });
  const renderSearchResults = () => {
    if (aiSearchRequestStatus === requestStatusTypes.PENDING || aiSearchRequestStatus === requestStatusTypes.UNINITIALIZED) {
      return loadingSkeletonArray.map((_, index) => /*#__PURE__*/_jsx(AiSearchResultItemSkeleton, {}, index));
    }
    if (aiSearchRequestStatus === requestStatusTypes.FAILED) {
      return /*#__PURE__*/_jsx(AiSearchResultsError, {});
    }
    return /*#__PURE__*/_jsx(AiSearchResultsContainer, {
      templateSuggestions: aiSearchResponse === null || aiSearchResponse === void 0 ? void 0 : aiSearchResponse.templateSuggestions,
      search: search,
      chatId: aiSearchResponse === null || aiSearchResponse === void 0 ? void 0 : aiSearchResponse.chatId
    });
  };
  return /*#__PURE__*/_jsxs(Grid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 12
      },
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        flexDirection: "row",
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "h2",
            typography: "heading-300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reports.aiSearch.breezeHeading"
            })
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "detail-100",
            color: "text-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reports.aiSearch.disclaimer"
            })
          }), /*#__PURE__*/_jsx(Box, {
            marginInlineStart: "300",
            children: /*#__PURE__*/_jsx(AIBadge, {})
          })]
        })]
      })
    }), renderSearchResults()]
  });
};
export default AiReadyMadeReportsContainer;